/* ======================================================================
   POOL PRODUCT CARD — BEHAVIOUR

   Do cheezein:
     1. Wishlist heart. /pages/wishlist pehle se localStorage ki
        "wg_wishlist" key parhta tha, magar usay bharne wala koi
        control kahin nahi tha — is liye wishlist hamesha khali rehti
        thi. Ab dil yahin se likhta hai, usi shakal mein jo wo page
        expect karta hai: { handle, url, title, price, image }.
     2. Quick add. Bag button seedha cart mein daalta hai. Multi-variant
        products ke liye pehla available variant jata hai.

   Add karne ka tareeqa theme ka apna hai — pehle
   "cart:prepare-bundled-sections", phir cart/add.js ke saath sections,
   phir "variant:add" aur "cart:change". Sirf fetch karke chhor dene se
   cart drawer aur cart bubble refresh nahi hote the, aur user ko lagta
   tha ke kuch add hua hi nahi.

   Delegation par chalta hai, is liye slider, filters ya section
   re-render ke baad naye cards ko dobara bind karne ki zaroorat nahi.
   ====================================================================== */

(function () {
  'use strict';

  var WISHLIST_KEY = 'wg_wishlist';
  var BUNDLED_SECTIONS = ['variant-added', 'cart-drawer', 'cart-icon-bubble'];

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- WISHLIST STORAGE ---------- */

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      /* Private mode ya bhara hua storage — wishlist us session mein
         kaam nahi karegi, magar page tootna nahi chahiye. */
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      return false;
    }

    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
    return true;
  }

  function inWishlist(list, handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].handle === handle) return true;
    }
    return false;
  }

  function paintHearts(root) {
    var list = readWishlist();
    var hearts = (root || document).querySelectorAll('[data-ppc-wish]');

    for (var i = 0; i < hearts.length; i++) {
      var handle = hearts[i].getAttribute('data-handle');
      var title = hearts[i].getAttribute('data-title') || 'product';
      var saved = inWishlist(list, handle);
      hearts[i].setAttribute('aria-pressed', saved ? 'true' : 'false');
      hearts[i].setAttribute('aria-label', (saved ? 'Remove ' + title + ' from wishlist' : 'Add ' + title + ' to wishlist'));
    }
  }

  function toggleWishlist(button) {
    var handle = button.getAttribute('data-handle');
    if (!handle) return;

    var list = readWishlist();

    if (inWishlist(list, handle)) {
      list = list.filter(function (item) {
        return item && item.handle !== handle;
      });
    } else {
      list.push({
        handle: handle,
        url: button.getAttribute('data-url') || '',
        title: button.getAttribute('data-title') || '',
        price: button.getAttribute('data-price') || '',
        image: button.getAttribute('data-image') || ''
      });
    }

    writeWishlist(list);
    paintHearts();
  }

  /* ---------- QUICK ADD ---------- */

  function flashDone(button) {
    button.classList.add('is-done');
    setTimeout(function () {
      button.classList.remove('is-done');
    }, 1400);
  }

  function quickAdd(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-busy')) return;

    button.classList.add('is-busy');

    /* Theme ko pehle batana parta hai ke kaun se sections chahiye,
       warna wo add ke jawab mein aaye hue section HTML ko nazarandaz
       kar deta hai. */
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: BUNDLED_SECTIONS }
      })
    );

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: BUNDLED_SECTIONS
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'add-to-cart failed');
          return data;
        });
      })
      .then(function (added) {
        var settings = (window.themeVariables && window.themeVariables.settings) || {};

        /* Cart page wale stores par drawer hota hi nahi, is liye wahan
           seedha cart par bhej dete hain. */
        if (settings.cartType === 'page' || settings.pageType === 'cart') {
          window.location.href = rootUrl() + 'cart';
          return;
        }

        return fetch(rootUrl() + 'cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            cart.sections = added.sections;

            button.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: added.items ? added.items : [added],
                  cart: cart
                }
              })
            );

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'quick-add', cart: cart }
              })
            );

            flashDone(button);
          });
      })
      .catch(function () {
        /* Pehle yahan se product page khul jata tha. Wo user ko carousel
           se bahar phenk deta hai aur lagta hai jaise button ka kaam hi
           yehi ho — is liye ab sirf button par nishan lagta hai aur
           shopper wahin ka wahin rehta hai. */
        button.classList.add('is-error');
        setTimeout(function () {
          button.classList.remove('is-error');
        }, 2000);
      })
      .then(function () {
        button.classList.remove('is-busy');
      });
  }

  /* ---------- WIRING ---------- */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var wish = event.target.closest('[data-ppc-wish]');
    if (wish) {
      event.preventDefault();
      toggleWishlist(wish);
      return;
    }

    var add = event.target.closest('[data-ppc-add]');
    if (add) {
      event.preventDefault();
      quickAdd(add);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paintHearts();
    });
  } else {
    paintHearts();
  }

  /* Theme editor har edit par section dobara render karta hai, aur
     naye hearts default (khali) shakal mein aate hain. */
  document.addEventListener('shopify:section:load', function () {
    paintHearts();
  });

  window.addEventListener('wishlist:updated', function () {
    paintHearts();
  });
})();